module.exports = __webpack_public_path__ + "static/media/71+AZqKge3L._AC_SL1500_.2cab798d.jpg";